import { cn } from "@/domains/library"

export interface CheckboxProps {
  disabled?: boolean
  defaultChecked?: boolean
  id: string
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
}

const Checkbox = (props: CheckboxProps) => {
  return (
    <div className="flex gap-2">
      <input
        className={cn(
          "disabled:border-1 peer relative mt-1 h-[22px] w-[22px] shrink-0 cursor-pointer",
          "appearance-none rounded-md",
          "bg-p300 hover:bg-p300-light",
          "border-p400-light hover:border-p200 border",
          // "checked:border-primary-600 checked:bg-gradient-to-b checked:from-primary-500 checked:via-primary-600 checked:to-primary-700",
          "checked:border-p100-shade checked:hover:border-p100",
          "checked:bg-p100 hover:checked:bg-p100-light",
          "focus:outline-none focus:ring-0 focus:ring-ring focus:ring-offset-0",
          "disabled:border-p400-light disabled:bg-p400 disabled:cursor-not-allowed",
          props.className,
        )}
        type="checkbox"
        id={props.id}
        value={props.id}
        checked={props.checked}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      <svg
        className={cn(
          "pointer-events-none absolute ml-[2.5px] mt-[6px] hidden h-[18px] w-[18px] stroke-white outline-none peer-checked:block",
          props.className,
        )}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="18 6 10 17 5 12"></polyline>
      </svg>
    </div>
  )
}

export { Checkbox }
